// Import y'all
import { yall } from '../../vendor/yall-js/yall';

// Invoke!
yall();